module.exports = __webpack_public_path__ + "static/media/LSP.d72c357a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/LSP.jpg
// module id = 489
// module chunks = 0